import { CognitoUser } from 'amazon-cognito-identity-js';
import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';
import userpool from './userpool';
import config from '../../config';
import { authconfig } from '../shared/utils/common';
import axios from 'axios';
import { errorOccuredAndLogged_Mixpanel } from '../shared/mixpanel/mixpanel';
import { CONNECTIVITY_ISSUE } from '../constants/mixPannelConstants';

let cognitoUser;
const client = new CognitoIdentityProviderClient({
  region: process.env.REGION,
  apiVersion: process.env.VERSION
});

/* GET USER ATTRIBUTES */

export const getUserInfoAndCheckAdmin = (userName) => {
  //need to check the amazonWebServiceSelector.js and then remove this
  return new Promise((resolve, reject) => {
    cognitoUser.getUserAttributes(function (err, result) {
      if (err) {
        reject(err);
      }
      resolve({ att: result, isAdmin: result.filter(att => att.Name === 'custom:isAdmin' && att.Value === 'true').length > 0 });
    });
  })
};

export const forgotPasswordCall = (username) => {
  //need to check the LoginIACM.js and then remove this
  return new Promise((resolve, reject) => {
    const userAuth = new CognitoUser({
      Username: username,
      Pool: userpool
    });
    userAuth.forgotPassword({
      onSuccess: (result) => {
        resolve(result);
      },
      onFailure: (err) => {
        console.log('err', err);
        reject(err);
      }
    });
  });
};

export const makeIacmLocationApi = async (code) => {
  //we are using this do not remove
  let configs = authconfig(config.env, 'vendor');
  
  return await axios
  .post(`${process.env.VENDOR_SERVICE_API}/iacm/location?code=${code}`, null, configs) 
    .then(res => {
      return res;
    }).catch(err => {
	  errorOccuredAndLogged_Mixpanel(err, 'IACM Location API', CONNECTIVITY_ISSUE);
      return err;
    })
}

export const makeIacmActivateLocationApi = async (locationId, accessTokenValue) => {
  //we are using this do not remove
  let configs = authconfig(config.env, 'vendor');
  return await axios
    .post(`${process.env.VENDOR_SERVICE_API}/iacm/activate?locationId=${locationId}`, null, {
      headers: {
          ...configs?.headers,
          'user_authentication':accessTokenValue
      }
  })
    .then(res => {
      return res;
    }).catch(err => {
	  errorOccuredAndLogged_Mixpanel(err, 'IACM Activate Location API', CONNECTIVITY_ISSUE);
      return err;
    })
}
